var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12,
    fill: "none",
    viewBox: "0 0 10 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.03701 5.0552C1.6884 3.0372 3.6481 0.653649 4.99961 0C6.36245 0.73919 8.27954 2.95461 7.95486 5.0552C7.63018 7.15579 7.09988 10.1104 7.09988 10.1104H2.89348C2.89348 10.1104 2.38562 7.07321 2.03701 5.0552ZM0.599609 7.68554L1.59617 6.38299L2.19961 10.1566L0.599609 11.1854V7.68554ZM8.40305 6.38299L9.39961 7.68554V11.1854L7.79961 10.1566L8.40305 6.38299ZM4.96809 12C4.2578 11.4988 3.79268 10.3992 3.79268 10.3992H6.19268C6.19268 10.3992 5.92753 11.2479 4.96809 12Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.2b76769fb44c4566e5b4e7a81a7db745.svg";
export { ForwardRef as ReactComponent };